export default {"src":"/_next/static/media/weebly.21a461af.svg","height":70,"width":200,"blurWidth":0,"blurHeight":0};